module.exports = __webpack_public_path__ + "static/media/arrow-down-one-on-one.a3cec613.svg";